module.exports = __webpack_public_path__ + "img/logo-feelgood-colored.29b5ca72.png";